import React from 'react';
import { FaPen, FaTrash, FaRegStar, FaStar } from 'react-icons/fa';

const NewsPostTable = ({ posts }: { posts: any[] }) => (
    <div className='p-6 px-0 overflow-scroll'>
        <table className='w-full mt-4 table-auto'>
            <thead>
                <tr>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50 text-center'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Titel
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Beschrijving
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Tag
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Aanbevolen
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Auteur
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Datum
                        </p>
                    </th>
                    <th className='p-4 transition-colors cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 hover:bg-blue-gray-50'>
                        <p className='flex items-center justify-between gap-2 font-sans text-sm antialiased font-normal leading-none text-blue-gray-900 opacity-70'>
                            Acties (In Ontwikkeling)
                        </p>
                    </th>
                </tr>
            </thead>
            <tbody>
            {posts.map(post => (
                <tr key={post.id}>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <a className='hover:text-accent' href={`https://robinhoodboechout.be/nieuws/${post.slug}`} target='_blank' rel='noopener noreferrer'>{post.title}</a>
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <p className='text-ellipsis truncate'>{post.description}</p>
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <div className='w-max'>
                            <div className='relative grid items-center px-2 py-1 font-sans text-xs font-bold text-green-900 uppercase rounded-md select-none whitespace-nowrap bg-green-500/20'>
                                <p>{post.tag}</p>
                            </div>
                        </div>
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        {post.featured ? <FaStar className='text-accent'/> : <FaRegStar/>}
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <p>{post.author}</p>
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <p>{(post.created_at.split('T')[0]).split('-').reverse().join('-')}</p>
                    </td>
                    <td className='p-4 border-b border-blue-gray-50'>
                        <button className='relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-sans text-xs font-medium uppercase text-gray-900 transition-all hover:bg-gray-900/10 active:bg-gray-900/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none' type='button'>
                          <span className='absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2'>
                            <FaPen/>
                          </span>
                        </button>
                        <button className='relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-sans text-xs font-medium uppercase text-gray-900 transition-all hover:bg-gray-900/10 active:bg-gray-900/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none' type='button'>
                            <span className='absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2'>
                            <FaTrash/>
                          </span>
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>
);

export default NewsPostTable;